<script setup lang="ts">
import type Schema from "~/types/Schema";
import type { PropType } from "vue";
import { codeToHtml } from "shiki";

const props = defineProps({
  schema: {
    type: Object as PropType<Schema>,
    required: true,
  },
});

const html = await codeToHtml(props.schema.jsonSchemaValidation, {
  lang: "json",
  theme: "github-dark",
});
</script>

<template>
  <div v-html="html" class="block [&>pre]:overflow-x-auto [&>pre]:rounded-md [&>pre]:p-4"></div>
</template>

<style scoped></style>
